import { useState } from 'react';
import TopNav from './components/TopNav';
import Hero from './components/Hero';
import CategoriesRail from './components/CategoriesRail';
import Feed from './components/Feed';
import Timeline from './components/Timeline';
import Review from './components/Review';
import Principles from './components/Principles';
import About from './components/About';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  const [activeCat, setActiveCat] = useState('all');
  const [keyword, setKeyword] = useState('');

  function handlePick(catKey: string) {
    setActiveCat(catKey);
    setKeyword('');
    document.getElementById('feed')?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <CategoriesRail onPick={handlePick} />
        <Feed activeCat={activeCat} onCat={setActiveCat} keyword={keyword} onKeyword={setKeyword} />
        <Timeline />
        <Review />
        <Principles />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}